<template>
  <div
    :style="`width: ${size}px; height: ${size}px;`"
    class="svg-wrapper"
  >
    <template v-if="name==='dashboard'">
      <svg
        v-if="!active"
        :style="`width: ${parseInt(size)-6}px; height: auto;`"
        viewBox="0 0 19 18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            :style="`stroke: ${color};`"
            d="M469,326.87v9.64a.68.68,0,0,0,.19.47.64.64,0,0,0,.45.19h3.86v-5.56a1,1,0,0,1,.28-.69,1,1,0,0,1,.69-.29h3.21a.92.92,0,0,1,.68.29,1,1,0,0,1,.28.69v5.56h3.86A.66.66,0,0,0,483,337a.67.67,0,0,0,.18-.47v-9.64"
            style="fill: none; stroke-linecap: round; stroke-linejoin: round;"
            transform="translate(-466.6 -319.67)"
          />
          <path
            :style="`stroke: ${color};`"
            d="M485.1,328.67l-8.56-8.34a.66.66,0,0,0-.87,0l-8.57,8.34m14.79-3.15v-4.7H480v2.82"
            style="fill: none; stroke-linecap: round; stroke-linejoin: round;"
            transform="translate(-466.6 -319.67)"
          />
        </g>
      </svg>

      <svg
        v-else
        :style="`width: ${parseInt(size)-6}px; height: auto;`"
        viewBox="0 0 18 17"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          :style="`fill: ${color};`"
          d="M503,322.8a.29.29,0,0,0-.21-.09.27.27,0,0,0-.2.09l-6.91,6.67a.36.36,0,0,0-.07.1.5.5,0,0,0,0,.12V336a1.21,1.21,0,0,0,.35.86,1.18,1.18,0,0,0,.85.36h3.6a.64.64,0,0,0,.43-.18.63.63,0,0,0,.17-.43V331.4a.31.31,0,0,1,.09-.22.33.33,0,0,1,.21-.09h3a.31.31,0,0,1,.3.31v5.16a.61.61,0,0,0,.6.61h3.6a1.18,1.18,0,0,0,.85-.36A1.21,1.21,0,0,0,510,336v-6.26a.25.25,0,0,0,0-.12.36.36,0,0,0-.07-.1Z"
          transform="translate(-493.81 -320.17)"
        />
        <path
          :style="`fill: ${color};`"
          d="M511.62,328.22l-2.81-2.72v-4.12a.61.61,0,0,0-.17-.43.62.62,0,0,0-.43-.18h-1.8a.61.61,0,0,0-.6.61v1.21l-2.17-2.1a1.17,1.17,0,0,0-.83-.32,1.19,1.19,0,0,0-.83.32l-8,7.73a.62.62,0,0,0-.05.84.48.48,0,0,0,.2.15.46.46,0,0,0,.23.06.5.5,0,0,0,.44-.17l7.78-7.52a.32.32,0,0,1,.42,0l7.78,7.52a.55.55,0,0,0,.43.17.6.6,0,0,0,.42-.18A.63.63,0,0,0,511.62,328.22Z"
          transform="translate(-493.81 -320.17)"
        />
      </svg>
    </template>

    <template v-else-if="name==='alerts'">
      <svg
        v-if="!active"
        :style="`width: ${parseInt(size)-9}px; height: auto;`"
        viewBox="0 0 16 19"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          :style="`stroke: ${color};`"

          d="M478.83,367.31V368a2.81,2.81,0,0,1-.8,2,2.69,2.69,0,0,1-3.85,0,2.81,2.81,0,0,1-.8-2v-.69m10-1.41c-1.09-1.36-1.86-2-1.86-5.8,0-3.44-1.73-4.66-3.15-5.25a.76.76,0,0,1-.42-.46,1.9,1.9,0,0,0-3.75,0,.76.76,0,0,1-.42.46c-1.42.59-3.15,1.81-3.15,5.25,0,3.75-.77,4.44-1.87,5.8a.88.88,0,0,0,.74,1.41h13.15A.87.87,0,0,0,483.41,365.9Z"
          style="fill: none; stroke-linecap: round; stroke-linejoin: round;"
          transform="translate(-468.1 -352.27)"
        />
      </svg>

      <svg
        v-else
        :style="`width: ${parseInt(size)-9}px; height: auto;`"
        viewBox="0 0 15 18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          :style="`fill: ${color};`"
          d="M510,365.2l-.2-.24c-.85-1.07-1.37-1.72-1.37-4.74a6.25,6.25,0,0,0-1.09-3.82,5.06,5.06,0,0,0-2.18-1.65l0,0a2.34,2.34,0,0,0-4.62,0l0,0c-2.2.93-3.27,2.72-3.27,5.47,0,3-.52,3.67-1.38,4.74a2.51,2.51,0,0,0-.19.24,1.37,1.37,0,0,0-.31.72,1.46,1.46,0,0,0,1.47,1.63h12a1.47,1.47,0,0,0,1.34-.84,1.49,1.49,0,0,0,.12-.78A1.44,1.44,0,0,0,510,365.2Zm-7.19,5.57a3,3,0,0,0,1.6-.46,3.1,3.1,0,0,0,1.15-1.23.31.31,0,0,0,0-.08.19.19,0,0,0,0-.08.34.34,0,0,0-.06-.06l-.08,0H500.2l-.08,0a.1.1,0,0,0-.05.06.11.11,0,0,0,0,.08.31.31,0,0,0,0,.08,3.24,3.24,0,0,0,1.15,1.23A3,3,0,0,0,502.81,370.77Z"
          transform="translate(-495.31 -352.77)"
        />
      </svg>
    </template>

    <template v-else-if="name==='risk'">
      <svg
        v-if="!active"
        :style="`width: ${parseInt(size)-6}px; height: auto;`"
        viewBox="0 0 19 19"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            :style="`stroke: ${color};`"
            d="M476.11,387.78l.69,0a8.31,8.31,0,1,1-7.92,10.84"
            style="stroke-miterlimit : 10; fill: none; stroke-linecap : round;"
            transform="translate(-466.6 -385.87)"
          />
          <path
            :style="`stroke: ${color};`"
            d="M476.1,386.37a9,9,0,0,0-8.21,12.68l8.21-3.68Z"
            style="stroke-linejoin : round; fill: none; stroke-linecap : round;"
            transform="translate(-466.6 -385.87)"
          />
        </g>
      </svg>

      <svg
        v-else
        :style="`width: ${parseInt(size)-6}px; height: auto;`"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          :style="`fill: ${color};`"
          d="M495.18,400.12a.64.64,0,0,1-.35-.1.63.63,0,0,1-.23-.28,9,9,0,0,1,3.91-11.58,9,9,0,0,1,4.3-1.1.66.66,0,0,1,.46.19.65.65,0,0,1,.18.46v8.35a.64.64,0,0,1-.38.59l-7.62,3.41A.66.66,0,0,1,495.18,400.12Z"
          transform="translate(-493.81 -387.06)"
        />
        <path
          :style="`fill: ${color};`"
          d="M505.13,388.52H505l-.12.06a.31.31,0,0,0-.09.11.35.35,0,0,0,0,.14v7.23a1.93,1.93,0,0,1-.31,1.05,1.85,1.85,0,0,1-.83.71l-6.93,3.11a.21.21,0,0,0-.11.08.47.47,0,0,0-.07.12.66.66,0,0,0,0,.14.31.31,0,0,0,.06.13,8.5,8.5,0,0,0,1.94,2,8.36,8.36,0,1,0,6.65-14.91Z"
          transform="translate(-493.81 -387.06)"
        />
      </svg>
    </template>

    <template v-else-if="name==='hedging'">
      <svg
        v-if="!active"
        :style="`width: ${parseInt(size)-8}px; height: auto;`"
        viewBox="0 0 17 19"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          :style="`stroke: ${color};`"

          d="M484.07,422.76a25.22,25.22,0,0,1-8-2.79,25.08,25.08,0,0,1-8,2.79c-.63,11.11,7.37,14.95,8,15.21C476.7,437.71,484.69,433.87,484.07,422.76Z"
          style="fill: none; stroke-linecap: round; stroke-linejoin: round; isolation: isolate;"
          transform="translate(-467.6 -419.47)"
        />
      </svg>

      <svg
        v-else
        :style="`width: ${parseInt(size)-8}px; height: auto;`"
        viewBox="0 0 16 18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          :style="`fill: ${color};`"
          d="M510.63,424.16a.67.67,0,0,1,.15.39,17.7,17.7,0,0,1-.87,6.8,14.6,14.6,0,0,1-2.56,4.52,13,13,0,0,1-4.32,3.44.54.54,0,0,1-.43,0,12.93,12.93,0,0,1-4.33-3.44,14.26,14.26,0,0,1-2.55-4.52,17.7,17.7,0,0,1-.88-6.8.67.67,0,0,1,.15-.39.5.5,0,0,1,.32-.2,23.43,23.43,0,0,0,7.27-2.54.46.46,0,0,1,.23-.06.53.53,0,0,1,.24.06,23.28,23.28,0,0,0,7.26,2.54A.5.5,0,0,1,510.63,424.16Z"
          transform="translate(-494.81 -421.36)"
        />
      </svg>
    </template>

    <template v-else-if="name==='alm'">
      <svg
        v-if="!active"
        :style="`width: ${parseInt(size)-8}px; height: auto;`"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >

        <path
          d="M17.3419 9.97436C17.3428 9.52396 17.2999 9.07455 17.2137 8.63248L19 7.60684L16.547 3.33333L14.7692 4.35897C14.082 3.77661 13.2941 3.32475 12.4444 3.02564V1H7.55556V3.05983C6.70587 3.35893 5.918 3.8108 5.23077 4.39316L3.45299 3.36752L1 7.64103L2.78632 8.66667C2.61536 9.55308 2.61536 10.464 2.78632 11.3504L1 12.3761L3.45299 16.6496L5.23077 15.6239C5.918 16.2063 6.70587 16.6582 7.55556 16.9573V18.9487H12.4444V16.8889C13.2941 16.5898 14.082 16.1379 14.7692 15.5556L16.547 16.5812L19 12.3077L17.2137 11.2821C17.2977 10.8512 17.3406 10.4133 17.3419 9.97436Z"
          :style="`stroke: ${color};`"
          fill="none"
          style="stroke-miterlimit: 10;"
        />
      </svg>

      <svg
        v-else
        :style="`width: ${parseInt(size)-8}px; height: auto;`"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.9443 2.67969C13.6146 2.95026 14.2445 3.31189 14.8164 3.75391L16.2969 2.90039L16.7314 2.64941L16.9805 3.08398L19.4336 7.3584L19.6826 7.79199L19.249 8.04004L17.7637 8.89258C17.7983 9.13161 17.8227 9.37201 17.834 9.61328L17.8418 9.97559C17.8408 10.3257 17.8148 10.6753 17.7646 11.0215L19.249 11.874L19.6826 12.123L19.4336 12.5566L16.9805 16.8301L16.7314 17.2646L16.2969 17.0146L14.8164 16.1602C14.2445 16.6022 13.6146 16.9638 12.9443 17.2344V19.4482H7.05566V17.3027C6.38513 17.032 5.75472 16.6708 5.18262 16.2285L3.70312 17.083L3.26855 17.333L3.01953 16.8984L0.566406 12.625L0.317383 12.1914L0.750977 11.9424L2.23535 11.0898C2.13205 10.3725 2.132 9.64405 2.23535 8.92676L0.750977 8.07422L0.317383 7.82617L0.566406 7.39258L3.01953 3.11816L3.26855 2.68359L3.70312 2.93457L5.18262 3.78809C5.7547 3.34585 6.38515 2.98453 7.05566 2.71387V0.5H12.9443V2.67969ZM9.99902 6.20996C7.91994 6.21013 6.23454 7.89553 6.23438 9.97461C6.23464 12.0536 7.92 13.7401 9.99902 13.7402C12.0782 13.7402 13.7644 12.0537 13.7646 9.97461C13.7645 7.89542 12.0782 6.20996 9.99902 6.20996Z"
          fill="white"
        />
      </svg>
    </template>

    <template v-else-if="name==='industry'">
      <svg
        v-if="!active"
        :style="`width: ${parseInt(size)-6}px; height: auto;`"
        viewBox="0 0 19 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            :style="`stroke: ${color};`"
            d="M467.1,468.36h18"
            style="fill: none; stroke-linecap: round; stroke-linejoin: round;"
            transform="translate(-466.6 -453.08)"
          />
          <path
            :style="`stroke: ${color};`"
            d="M477.39,468.36V454.22a.64.64,0,0,0-.19-.45.6.6,0,0,0-.45-.19H469a.6.6,0,0,0-.45.19.64.64,0,0,0-.19.45v14.14"
            style="fill: none; stroke-linecap: round; stroke-linejoin: round;"
            transform="translate(-466.6 -453.08)"
          />
          <path
            :style="`stroke: ${color};`"
            d="M483.82,468.36v-9a.65.65,0,0,0-.65-.64h-5.78"
            style="fill: none; stroke-linecap: round; stroke-linejoin: round;"
            transform="translate(-466.6 -453.08)"
          />
          <path
            :style="`stroke: ${color};`"
            d="M471,456.79h2.57"
            style="fill: none; stroke-linecap: round; stroke-linejoin: round;"
            transform="translate(-466.6 -453.08)"
          />
          <path
            :style="`stroke: ${color};`"
            d="M472.25,461.93h2.57"
            style="fill: none; stroke-linecap: round; stroke-linejoin: round;"
            transform="translate(-466.6 -453.08)"
          />
          <path
            :style="`stroke: ${color};`"
            d="M471,465.15h2.57"
            style="fill: none; stroke-linecap: round; stroke-linejoin: round;"
            transform="translate(-466.6 -453.08)"
          />
          <path
            :style="`stroke: ${color};`"
            d="M480,465.15h1.29"
            style="fill: none; stroke-linecap: round; stroke-linejoin: round;"
            transform="translate(-466.6 -453.08)"
          />
          <path
            :style="`stroke: ${color};`"
            d="M480,461.93h1.29"
            style="fill: none; stroke-linecap: round; stroke-linejoin: round;"
            transform="translate(-466.6 -453.08)"
          />
        </g>
      </svg>

      <svg
        v-else
        :style="`width: ${parseInt(size)-6}px; height: auto;`"
        viewBox="0 0 18 15"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          :style="`fill: ${color};`"
          d="M511.21,467.27h-.6v-7.8a1.2,1.2,0,0,0-1.2-1.2h-4.8v-3.6a1.2,1.2,0,0,0-1.2-1.2h-7.2a1.2,1.2,0,0,0-1.2,1.2v12.6h-.6a.6.6,0,0,0,0,1.2h16.8a.6.6,0,0,0,0-1.2Zm-9-5.4a.62.62,0,0,1-.6.6h-2.4a.6.6,0,0,1,0-1.2h2.4a.62.62,0,0,1,.6.6Zm-4.2-5.4h2.4a.6.6,0,0,1,0,1.2H498a.6.6,0,0,1,0-1.2Zm0,7.8h2.4a.6.6,0,0,1,0,1.2H498a.6.6,0,0,1,0-1.2Zm6.6-4.8h4.8v7.8h-4.8Z"
          transform="translate(-493.81 -453.47)"
        />
        <path
          :style="`fill: ${color};`"
          d="M507.61,464.27h-1.2a.6.6,0,0,0,0,1.2h1.2a.6.6,0,0,0,0-1.2Z"
          transform="translate(-493.81 -453.47)"
        />
        <path
          :style="`fill: ${color};`"
          d="M506.41,462.47h1.2a.6.6,0,0,0,0-1.2h-1.2a.6.6,0,0,0,0,1.2Z"
          transform="translate(-493.81 -453.47)"
        />
      </svg>
    </template>

    <template v-else-if="name==='positions'">
      <svg
        v-if="!active"
        :style="`width: ${parseInt(size)-4}px; height: auto;`"
        viewBox="0 0 20 11"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            :style="`fill: ${color};`"
            d="M483.93,486.14a.45.45,0,0,1,0,.61l-3.76,3.76a.45.45,0,0,1-.61,0,.43.43,0,0,1,0-.61l3.76-3.76A.43.43,0,0,1,483.93,486.14Zm-10.6,1a.42.42,0,0,1,0,.6l-4.45,4.45a.43.43,0,0,1-.6,0,.43.43,0,0,1,0-.61l4.44-4.44A.43.43,0,0,1,473.33,487.17Zm1.45,0a.42.42,0,0,1,.6,0l2.73,2.73a.43.43,0,0,1,0,.61.43.43,0,0,1-.6,0l-2.73-2.74A.42.42,0,0,1,474.78,487.17Z"
            style="fill-rule : evenodd;"
            transform="translate(-466.1 -483.97)"
          />
          <path
            :style="`fill: ${color};`"
            d="M484.65,484.82a.6.6,0,1,0,.6.6A.6.6,0,0,0,484.65,484.82Zm-1.45.6a1.45,1.45,0,1,1,1.45,1.45A1.45,1.45,0,0,1,483.2,485.42Z"
            style="fill-rule : evenodd;"
            transform="translate(-466.1 -483.97)"
          />
          <path
            :style="`fill: ${color};`"
            d="M478.84,490.63a.6.6,0,1,0,.6.6A.6.6,0,0,0,478.84,490.63Zm-1.45.6a1.45,1.45,0,1,1,1.45,1.45A1.45,1.45,0,0,1,477.39,491.23Z"
            style="fill-rule : evenodd;"
            transform="translate(-466.1 -483.97)"
          />
          <path
            :style="`fill: ${color};`"
            d="M474.05,485.85a.59.59,0,0,0-.6.59.6.6,0,1,0,1.2,0A.59.59,0,0,0,474.05,485.85Zm-1.45.59a1.45,1.45,0,1,1,1.45,1.46A1.45,1.45,0,0,1,472.6,486.44Z"
            style="fill-rule : evenodd;"
            transform="translate(-466.1 -483.97)"
          />
          <path
            :style="`fill: ${color};`"
            d="M467.56,492.34a.6.6,0,0,0,0,1.2.6.6,0,0,0,0-1.2Zm-1.46.6a1.46,1.46,0,1,1,1.46,1.45A1.45,1.45,0,0,1,466.1,492.94Z"
            style="fill-rule : evenodd;"
            transform="translate(-466.1 -483.97)"
          />
        </g>
      </svg>

      <svg
        v-else
        :style="`width: ${parseInt(size)-4}px; height: auto;`"
        viewBox="0 0 20 11"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          :style="`fill: ${color};`"
          d="M509.34,483a1.76,1.76,0,0,0-.78.19,1.61,1.61,0,0,0-.59.54,1.56,1.56,0,0,0-.28.75,1.69,1.69,0,0,0,.1.8l-3.51,3.5a1.68,1.68,0,0,0-1.21,0l-2.51-2.5a1.69,1.69,0,0,0,.11-.8,1.67,1.67,0,0,0-.28-.75,1.72,1.72,0,0,0-.6-.54,1.7,1.7,0,0,0-1.56,0,1.72,1.72,0,0,0-.6.54,1.67,1.67,0,0,0-.28.75,1.69,1.69,0,0,0,.11.8l-4.17,4.17a1.66,1.66,0,0,0-2,.64,1.65,1.65,0,0,0-.26,1.08,1.67,1.67,0,0,0,1.49,1.49,1.71,1.71,0,0,0,1.08-.26,1.69,1.69,0,0,0,.64-2l4.17-4.17a1.71,1.71,0,0,0,1.22,0l2.51,2.51a1.64,1.64,0,0,0-.11.79,1.67,1.67,0,0,0,.28.75,1.68,1.68,0,0,0,2.16.54,1.61,1.61,0,0,0,.59-.54,1.56,1.56,0,0,0,.28-.75,1.63,1.63,0,0,0-.1-.79l3.5-3.51a1.62,1.62,0,0,0,.72.11,1.83,1.83,0,0,0,.7-.2,1.69,1.69,0,0,0,.54-.49A1.46,1.46,0,0,0,511,485a1.64,1.64,0,0,0,0-.73,1.74,1.74,0,0,0-.33-.65,1.79,1.79,0,0,0-.58-.44A1.57,1.57,0,0,0,509.34,483Z"
          transform="translate(-491.01 -482.99)"
        />
      </svg>
    </template>

    <template v-else-if="name==='knowledge-center'">
      <svg
        v-if="!active"
        :style="`width: ${parseInt(size)-4}px; height: auto;`"
        viewBox="0 0 21 19"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            :style="`stroke: ${color};`"
            d="M476.44,527.14,470,523.57v-5.72l6.42,3.57m0,5.72,6.43-3.57v-5.72l-6.43,3.57m0,5.72v-5.72m10,2.15v-7.86"
            style="fill: none; stroke-linecap: round; stroke-linejoin: round;"
            transform="translate(-465.94 -509.5)"
          />
          <path
            :style="`stroke: ${color};`"
            d="M466.44,515.71l10-5.71,10,5.71-10,5.71Z"
            style="fill: none; stroke-linecap: round; stroke-linejoin: round;"
            transform="translate(-465.94 -509.5)"
          />
        </g>
      </svg>

      <svg
        v-else
        :style="`width: ${parseInt(size)-4}px; height: auto;`"
        viewBox="0 0 20 18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          :style="`fill: ${color};`"
          d="M501.66,524.25a.76.76,0,0,1-.33-.08l-5.83-3.3a.31.31,0,0,0-.34,0,.34.34,0,0,0-.12.12.32.32,0,0,0,0,.16v3.1a.67.67,0,0,0,.09.34.72.72,0,0,0,.25.24l6,3.3a.72.72,0,0,0,.32.08.73.73,0,0,0,.33-.08l6-3.3a.72.72,0,0,0,.25-.24.67.67,0,0,0,.09-.34v-3.1a.47.47,0,0,0,0-.16.37.37,0,0,0-.13-.12.33.33,0,0,0-.16,0,.34.34,0,0,0-.17,0l-5.84,3.3A.73.73,0,0,1,501.66,524.25Z"
          transform="translate(-491.67 -511.07)"
        />
        <path
          :style="`fill: ${color};`"
          d="M511.66,516.94h0a.63.63,0,0,0-.1-.29.66.66,0,0,0-.23-.21L502,511.16a.66.66,0,0,0-.33-.09.63.63,0,0,0-.33.09L492,516.43a.69.69,0,0,0-.24.24.65.65,0,0,0,0,.66.62.62,0,0,0,.24.24l9.34,5.28a.73.73,0,0,0,.33.08.76.76,0,0,0,.33-.08l8.21-4.64h.08l0,0s0,0,0,0v6a.68.68,0,0,0,.64.68.57.57,0,0,0,.26,0,.68.68,0,0,0,.23-.14.54.54,0,0,0,.15-.22.58.58,0,0,0,.06-.26V517A.13.13,0,0,0,511.66,516.94Z"
          transform="translate(-491.67 -511.07)"
        />
      </svg>
    </template>

    <template v-else-if="name==='help'">
      <svg
        v-if="!active"
        :style="`width: ${parseInt(size)-6}px; height: auto;`"
        viewBox="0 0 19 19"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            :style="`stroke: ${color};`"
            class="cls-2"
            d="M477.39,542.74a9,9,0,1,0,6.36,2.64A9,9,0,0,0,477.39,542.74Z"
            style="fill: none; stroke-miterlimit : 10;"
            transform="translate(-467.89 -542.24)"
          />
          <path
            :style="`stroke: ${color};`"
            class="cls-3"
            d="M474.53,549a2.48,2.48,0,0,1,1-1.66,3,3,0,0,1,1.86-.6,3.14,3.14,0,0,1,1.36.23,2.33,2.33,0,0,1,1.5,2.1c0,1.33-.87,1.93-1.86,2.6a2.41,2.41,0,0,0-1.26,2.13"
            style="fill: none; stroke-miterlimit : 10; stroke-linecap: round; stroke-width: 1.5px;"
            transform="translate(-467.89 -542.24)"
          />
          <path
            :style="`fill: ${color};`"
            d="M477.39,557.47a.82.82,0,1,0-.82-.82A.82.82,0,0,0,477.39,557.47Z"
            transform="translate(-467.89 -542.24)"
          />
        </g>
      </svg>

      <svg
        v-else
        :style="`width: ${parseInt(size)-6}px; height: auto;`"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          :style="`fill: ${color};`"
          d="M501.39,542.74a9,9,0,1,0,9,9A9,9,0,0,0,501.39,542.74ZM501.1,557a.91.91,0,0,1-.52-.16.94.94,0,0,1-.34-.42,1,1,0,0,1-.06-.54,1,1,0,0,1,.74-.74,1,1,0,0,1,.54.06.94.94,0,0,1,.42.34.91.91,0,0,1,.16.52.92.92,0,0,1-.94.94Zm1.57-4.78a1.55,1.55,0,0,0-.86,1.41.66.66,0,0,1-.19.46.68.68,0,0,1-.47.19.66.66,0,0,1-.46-.19.63.63,0,0,1-.2-.46,2.89,2.89,0,0,1,1.45-2.5c.9-.61,1.41-1,1.41-1.84a1.45,1.45,0,0,0-1-1.33,2.49,2.49,0,0,0-1-.15,2,2,0,0,0-1.3.41,1.66,1.66,0,0,0-.67,1,.78.78,0,0,1-.07.25.55.55,0,0,1-.15.2.61.61,0,0,1-.22.13.55.55,0,0,1-.25,0,.54.54,0,0,1-.25-.06.8.8,0,0,1-.21-.15,1,1,0,0,1-.13-.22.75.75,0,0,1,0-.26,2.94,2.94,0,0,1,1.17-2,3.3,3.3,0,0,1,2.1-.7,3.78,3.78,0,0,1,1.54.28,2.75,2.75,0,0,1,1.76,2.51C504.67,550.87,503.61,551.58,502.67,552.21Z"
          transform="translate(-492.39 -542.74)"
        />
      </svg>
    </template>

    <template v-else-if="name==='refresh'">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_2731_24364)">
          <path
            d="M18 3.40991C19.8228 4.69125 21.1908 6.51923 21.906 8.62944C22.6213 10.7397 22.6467 13.0227 21.9786 15.1483C21.3105 17.2739 19.9836 19.1319 18.1897 20.4535C16.3959 21.7751 14.2281 22.4918 12 22.4999"
            stroke="#3D68D5"
            stroke-width="1.5"
            stroke-miterlimit="10"
          />
          <path
            d="M6 20.59C4.17716 19.3087 2.80919 17.4807 2.09395 15.3705C1.37871 13.2603 1.3533 10.9772 2.02138 8.85161C2.68946 6.726 4.0164 4.86802 5.81026 3.54642C7.60412 2.22482 9.77188 1.50812 12 1.5"
            stroke="#3D68D5"
            stroke-width="1.5"
            stroke-miterlimit="10"
          />
          <path
            d="M17.73 8.17991V3.40991H22.5"
            stroke="#3D68D5"
            stroke-width="1.5"
            stroke-miterlimit="10"
          />
          <path
            d="M6.27 15.8201V20.5901H1.5"
            stroke="#3D68D5"
            stroke-width="1.5"
            stroke-miterlimit="10"
          />
        </g>
        <defs>
          <clipPath id="clip0_2731_24364">
            <rect
              width="24"
              height="24"
              fill="white"
            />
          </clipPath>
        </defs>
      </svg>
    </template>

    <template v-else-if="name==='success'">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_3092_16206)">
          <path
            d="M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5Z"
            stroke="#4CAF50"
            stroke-width="1.5"
            stroke-miterlimit="10"
          />
          <path
            d="M6.27002 11.9999L10.09 15.8199L17.73 8.17993"
            stroke="#4CAF50"
            stroke-width="1.5"
            stroke-miterlimit="10"
          />
        </g>
        <defs>
          <clipPath id="clip0_3092_16206">
            <rect
              width="24"
              height="24"
              fill="white"
            />
          </clipPath>
        </defs>
      </svg>
    </template>
    <template v-else-if="name==='withdrawn_per_day'">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.3333 8H3"
          stroke="#E52C2C"
          stroke-miterlimit="10"
        />
        <path
          d="M11 4L15 8L11 12"
          stroke="#E52C2C"
          stroke-miterlimit="10"
        />
        <path
          d="M7 5.5V3H1V13H7V10.5"
          stroke="#E52C2C"
        />
      </svg>
    </template>
    <template v-else-if="name==='cumulative_withdrawns'">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.3333 12H2"
          stroke="#E52C2C"
          stroke-miterlimit="10"
        />
        <path
          d="M11 8H2"
          stroke="#E52C2C"
          stroke-miterlimit="10"
        />
        <path
          d="M7 4H2"
          stroke="#E52C2C"
          stroke-miterlimit="10"
        />
        <path
          d="M12 10L14 12L12 14"
          stroke="#E52C2C"
          stroke-miterlimit="10"
        />
      </svg>
    </template>
    <template v-else-if="name==='deployed_per_day'">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.3333 8H1"
          stroke="#63747D"
          stroke-miterlimit="10"
        />
        <path
          d="M7 4L11 8L7 12"
          stroke="#63747D"
          stroke-miterlimit="10"
        />
        <path
          d="M9 13L15 13L15 3L9 3"
          stroke="#63747D"
        />
      </svg>
    </template>
    <template v-else-if="name==='deployed_funds'">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.3333 8H8"
          stroke="#63747D"
          stroke-miterlimit="10"
        />
        <path
          d="M11 4L15 8L11 12"
          stroke="#63747D"
          stroke-miterlimit="10"
        />
        <path
          d="M3.72852 3V4.3619"
          stroke="#63747D"
          stroke-miterlimit="10"
          stroke-linecap="square"
        />
        <path
          d="M3.72852 11.6382V13.0001"
          stroke="#63747D"
          stroke-miterlimit="10"
          stroke-linecap="square"
        />
        <path
          d="M1 10.2713C1 10.6338 1.14399 10.9814 1.40029 11.2377C1.65659 11.494 2.0042 11.638 2.36667 11.638H4.6381C5.12054 11.638 5.58322 11.4464 5.92436 11.1052C6.26549 10.7641 6.45714 10.3014 6.45714 9.81896C6.45714 9.33652 6.26549 8.87384 5.92436 8.5327C5.58322 8.19156 5.12054 7.99991 4.6381 7.99991H2.81905C2.33661 7.99991 1.87392 7.80826 1.53279 7.46713C1.19165 7.12599 1 6.66331 1 6.18086C1 5.69842 1.19165 5.23574 1.53279 4.8946C1.87392 4.55347 2.33661 4.36182 2.81905 4.36182H5.09048C5.45294 4.36182 5.80056 4.5058 6.05686 4.7621C6.31316 5.0184 6.45714 5.36602 6.45714 5.72848"
          stroke="#63747D"
          stroke-miterlimit="10"
          stroke-linecap="square"
        />
      </svg>
    </template>
    <template v-else-if="name==='rates'">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 3.5H19C19.8284 3.5 20.5 4.17157 20.5 5V19C20.5 19.8284 19.8284 20.5 19 20.5H5C4.17157 20.5 3.5 19.8284 3.5 19V5C3.5 4.17157 4.17157 3.5 5 3.5Z"
          stroke="white"
        />
        <path
          d="M5.5 18.5L10 11L13.5 13L18 6"
          stroke="white"
          stroke-width="2"
          stroke-miterlimit="10"
        />
      </svg>
    </template>
  </div>
</template>

<script>
export default {
  name : 'SynthesisIcon',
  props: {
    name: {
      type   : String,
      default: ''
    },
    color: {
      type   : String,
      default: '#ffffff'
    },
    size: {
      type   : [String, Number],
      default: 24
    },
    active: {
      type   : Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.svg-wrapper {
  display: flex;
  align-items: center;
  height: 100%;
}

.svg-wrapper > svg {
  display: block;
  margin: 0 auto;
  text-align: center;
}
</style>
